import BaseCheckbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export default class CheckboxField extends React.PureComponent {
  static propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.node,
  };

  onChange = ({ target: { checked } }) => this.props.onChange?.(checked);

  render() {
    const { value, className, onChange, label, disabled, ...rest } = this.props;
    return (
      <FormControlLabel
        className={classnames("container", className, { disabled })}
        label={label}
        control={
          <BaseCheckbox onChange={this.onChange}
                        color="primary"
                        disableRipple
                        disableFocusRipple
                        disableTouchRipple
                        className='checkbox'
                        checked={value}
                        disabled={disabled}
                        {...rest}
          />}
      />
    );
  }
}
